import { Badge, Group } from "@mantine/core"
import uniq from "lodash/uniq"
import type { IMultiAnswerProps } from "./types"
import { filterAnswersWithValue } from "./utils"

export function MultiAnswerNumber({ answers }: IMultiAnswerProps) {
  const values = uniq(filterAnswersWithValue(answers).map((a) => a.value)).sort((a, b) => a - b)
  return (
    <Group gap="xs">
      {values.map((value) => (
        <Badge key={value} size="xl" radius="md" fz="md" fw={500}>
          {value}
        </Badge>
      ))}
    </Group>
  )
}
